export default "/grid.e36c0bf5afdfbeb97f0f57486b1827cd.svg";